import { render, staticRenderFns } from "./edit-car.vue?vue&type=template&id=5229292f"
import script from "./edit-car.vue?vue&type=script&lang=js"
export * from "./edit-car.vue?vue&type=script&lang=js"
import style0 from "./edit-car.vue?vue&type=style&index=0&id=5229292f&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports